<template>
<div ref="messageList" class="message-list">
    <div v-for="ticketMessage in supportTicketMessages" :key="ticketMessage.message_id">
        <TicketMessage :message="ticketMessage"></TicketMessage>
    </div>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import TicketMessage from "@/components/support/TicketMessage";

export default {
    name: "TicketMessageList",

    components: {
        TicketMessage
    },

    data() {
        return {
            offset: 20,
            allMessagesLoaded: false,
            isLoading: false,
        }
    },


	created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },

    methods: {
        handleScroll() {
            if (this.allMessagesLoaded || this.isLoading) {
                return;
            }

			var top = window.scrollY || window.scrollTop;

            if (window.innerHeight + top >= document.body.scrollHeight) {
                var params = {
                    offset: this.offset,
                    limit: 20,
                    id: this.$route.params.id,
                };
                var oldSize = this.supportTicketMessages.length;

                this.isLoading = true;

                var temp = this;
                this.$store.dispatch("loadMoreTicketMessages", params).then(function () {
                    temp.isLoading = false;
                    var newSize = temp.supportTicketMessages.length;
                    if (newSize == oldSize) {
                        temp.allMessagesLoaded = true;
                    }
                })
                this.offset += 20;
            }
        },
        scrollToBottom() {
            this.$refs.messageList.scrollTop = this.$refs.messageList.scrollHeight;
        }
    },

    computed: {
        ...mapGetters(["supportTicket", "supportTicketMessages"]),
    },
}
</script>

